export const tabType = {
    vocabulary: 'vocabulary',
    example: 'example',
    plus: 'plus',
    extra: 'extra'
};